// api.js
import axios from 'axios';
import { API_BASE_URL, USUARIOACCION, FECHAHORA, LOGERRORINSERT, AUDITORIA, TIEMPOEXPIRACIONCOOKIEENMINUTOS } from '../services/apiConfig';

// Función para obtener el token
const getAuthToken = () => {
  return sessionStorage.getItem("authToken") || '';
};

export const registrarAccion = async (usuario, navega) => {
  try {
    const TOKEN = getAuthToken();
    const response = await axios.post(API_BASE_URL + USUARIOACCION, {
      usuarioid: usuario,
      navego: navega,
    }, {
      headers: TOKEN ? { 'Authorization': `Bearer ${TOKEN}` } : {}
    });
    
    if (response.status === 200) {
      console.log('Registro de acción exitoso:', response.data);
    } else {
      console.error('Error al registrar la acción:', response.status);
      registrarLogError(usuario, navega, response.status);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud:', error.message);
    registrarLogError(usuario, navega, JSON.stringify(error));
  }
};

export const registrarLogError = async (usuario, aplicacion, error) => {
  try {
    const TOKEN = getAuthToken();
    const response = await axios.post(API_BASE_URL + LOGERRORINSERT, {
      usuarioid: usuario,
      error: error,
      aplicacion: aplicacion,
    }, {
      headers: TOKEN ? { 'Authorization': `Bearer ${TOKEN}` } : {}
    });
    
    if (response.status === 200) {
      console.log('Registro de error exitoso:', response.data);
    } else {
      console.error('Error al registrar el error:', response.status);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud:', error.message);
  }
};

export const isAuthenticated = (componente) => {
  const token = sessionStorage.getItem('authToken');
  const expiryTimeStr = sessionStorage.getItem('expiryTime');
  const currentTime = new Date().getTime();
  const loggedIn = sessionStorage.getItem('loggedIn');

  if (loggedIn && token && expiryTimeStr && currentTime < parseInt(expiryTimeStr)) {
    const maxAgeMs = (TIEMPOEXPIRACIONCOOKIEENMINUTOS || 15) * 60 * 1000;
    const newExpiryTime = currentTime + maxAgeMs;
    sessionStorage.setItem("expiryTime", newExpiryTime.toString());
    return true;
  }
  
  if (componente) {
    registrarLogError('unlogin', componente, 'usuario no logueado. token: ' + token);
  }

  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('expiryTime');
  sessionStorage.removeItem('loggedIn');
  sessionStorage.clear();

  return false;
};

export const registrarAuditoria = async (accion, modulo, registro, identificador, observaciones, origen, usuarioid) => {
  try {
    const TOKEN = getAuthToken();
    const response = await axios.post(API_BASE_URL + AUDITORIA, {
      accion: accion,
      modulo: modulo,
      registro: registro,
      identificador: identificador,
      observaciones: observaciones,
      origen: origen,
      usuarioid: usuarioid
    }, {
      headers: TOKEN ? { 'Authorization': `Bearer ${TOKEN}` } : {}
    });
  } catch (error) {
    console.error('Error al registrar auditoría:', error);
  }
};

export const getServerDateTime = async () => {
  try {
    const response = await axios.get(API_BASE_URL + FECHAHORA);
    return response.data.serverDateTime;
  } catch (error) {
    console.error('Error al obtener la fecha y hora del servidor:', error);
    throw error;
  }
};

export const getServerHora = async () => {
  try {
    const response = await axios.get(API_BASE_URL + FECHAHORA);
    return response.data.serverHora;
  } catch (error) {
    console.error('Error al obtener la hora del servidor:', error);
    throw error;
  }
};
